import { useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/common/Button";

export function FloatingApplyButton() {
  const { pathname } = useLocation();

  // /apply page par button dikhane ki zarurat nahi
  if (pathname.startsWith("/apply")) return null;

  return (
    <motion.div
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.6 }}
    >
      <Button
        to="/apply"
        size="md"
        className="shadow-xl shadow-black/40"
        data-testid="floating-apply-btn"
      >
        Apply Now <ArrowRight className="h-4 w-4" />
      </Button>
    </motion.div>
  );
}